import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var chevron_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z" }) });
export {
  chevron_left_default as default
};
//# sourceMappingURL=chevron-left.js.map
